"use client";
import type { TechModule } from "@/sanity.types";
import anim from "@assets/lottie/tech_lottie.json";
import Lottie from "lottie-react";
import BtnMain from "../../buttons/BtnMain/BtnMain";
import dots from "@assets/images/tech_dots.svg";
import Image from "next/image";
import { useRef } from "react";
import { useInView } from "framer-motion";
import clsx from "clsx";

const TechModule = ({ moduleData, lng }: { moduleData: TechModule; lng: string }) => {
	const ref = useRef<HTMLDivElement>(null);
	const isInView = useInView(ref, { amount: 0.5, once: true });

	return (
		<section
			ref={ref}
			className={clsx(
				isInView ? "translate-y-0 opacity-100" : "translate-y-20 opacity-0",
				"mx-grid-s mb-grid-s mt-48 flex aspect-[925/200] items-center rounded-[1.25rem] bg-gray-200 duration-500 xs:mx-0 xs:mb-0 xs:mt-20 xs:aspect-[245/300] xs:flex-col xs:justify-center xs:rounded-none",
			)}
		>
			<div className="relative isolate flex h-full basis-1/2 justify-center sm:h-full xs:h-[40%] xs:w-full">
				<div className="relative h-full w-fit -translate-y-[25%] sm:h-[140%] sm:-translate-y-1/2 xs:h-auto xs:w-full xs:-translate-y-[50%]">
					<Lottie animationData={anim} className="h-[150%] object-contain xs:w-full" />
					<Image
						src={dots.src}
						alt="Background dots"
						height={dots.height}
						width={dots.width}
						className="absolute bottom-0 left-1/2 -z-10 h-[85%] -translate-x-[40%] xs:hidden"
					/>
				</div>
			</div>
			<div className="py-4 pr-[5%] sm:py-6 xs:flex xs:flex-col xs:items-center xs:justify-center xs:px-grid-xs xs:pt-0">
				<h3 className="mb-8 text-h3 sm:text-center sm:text-h4-xs xs:w-10/12">{moduleData.title}</h3>
				<BtnMain label={moduleData.cta?.label || ""} href={`/${lng}${moduleData.cta?.url}`} black />
			</div>
		</section>
	);
};

export default TechModule;
